import { ReactElement } from 'react';
import { UserField, BoundStateFilterField, ActivityField, AgencyActivityTypesField } from 'components';
import { DatePickerField, SelectField, TextField } from '@ff-it/form';
import { CompanyField } from 'modules/core/company/components';
import { Box } from '@ff-it/ui';
import { OutletOrServiceCategoryField } from 'modules/supplier/outletOrServiceCategory/OutletOrServiceCategoryField';
import { BlockStateField } from '../status/BlockStateField';
import { CampaignStateField } from '../status/CampaignStateField';

interface FilterProps {
  scope: 'campaign' | 'block';
}

const viewOptions = [
  { label: 'Managed', value: 'MANAGED' },
  { label: 'Planned', value: 'PLANNED' },
  { label: 'Managed OR Planned', value: 'MANAGED_OR_PLANNED' },
];

export function Filter({ scope }: FilterProps): ReactElement {
  return (
    <Box alignItems="flex-start">
      <div className="flex-column">
        <div className="d-flex flex-row flex-wrap">
          <TextField name="search" placeholder="Search.." size="sm" />
          <CompanyField
            name="related_client"
            placeholder="Client or payer"
            className="ml-1"
            simple
            size="sm"
            includeBranches={true}
          />
          {scope === 'campaign' ? (
            <CampaignStateField name="sums__state" placeholder="State" className="ml-1" isMulti size="sm" />
          ) : (
            <BlockStateField name="state" placeholder="State" className="ml-1" isMulti size="sm" />
          )}
          <DatePickerField name="date_from" placeholder="Date from" className="ml-1" size="sm" />
          <DatePickerField name="date_to" placeholder="Date to" className="ml-1" size="sm" />
          <SelectField
            placeholder="Visible"
            name="view"
            className="ml-1"
            size="sm"
            simple
            options={viewOptions}
            isClearable={true}
          />
        </div>
        <div className="d-flex flex-row">
          <AgencyActivityTypesField
            name="type"
            placeholder="Type"
            // className="ml-1"
            size="sm"
          />
          <UserField
            name="manager"
            placeholder="Manager"
            className="ml-1"
            size="sm"
            simple
            filter={{ manage_campaign: true }}
          />
          <UserField
            name="planner"
            placeholder="Planner"
            className="ml-1"
            size="sm"
            simple
            filter={{ plan_campaign_block: true }}
          />
          <BoundStateFilterField
            name="sums__income_state"
            placeholder="Income"
            isSearchable={false}
            className="ml-1"
            simple
            size="sm"
          />
          <BoundStateFilterField
            name="sums__expense_state"
            placeholder="Expense"
            isSearchable={false}
            className="ml-1"
            simple
            size="sm"
          />
        </div>
      </div>
    </Box>
  );
}

export function RowFilter(): ReactElement {
  return (
    <Box alignItems="flex-start">
      <div className="flex-column">
        <div className="d-flex flex-row ">
          <TextField name="search" placeholder="Search.." size="sm" />
          <CompanyField
            name="related_client"
            placeholder="Client or payer"
            className="ml-1"
            simple
            size="sm"
            includeBranches={true}
          />
          <ActivityField name="activity" placeholder="Activity" className="ml-1" simple size="sm" />
          <OutletOrServiceCategoryField
            name="product__outlet_or_service_category"
            placeholder="Outlet or service category"
            className="ml-1"
            simple
            size="sm"
          />
          <CompanyField
            name="provider"
            placeholder="Provider"
            className="ml-1"
            simple
            size="sm"
            includeBranches={true}
          />

          <DatePickerField name="date_from" placeholder="Date from" className="ml-1" size="sm" />
          <DatePickerField name="date_to" placeholder="Date to" className="ml-1" size="sm" />
        </div>
        <div className="d-flex flex-row">
          <BlockStateField name="block__state" placeholder="Block state" isMulti size="sm" />
          <AgencyActivityTypesField name="block__type" placeholder="Type" className="ml-1" size="sm" />
          <UserField
            name="manager"
            placeholder="Manager"
            className="ml-1"
            size="sm"
            simple
            filter={{ manage_campaign: true }}
          />
          <UserField
            name="planner"
            placeholder="Planner"
            className="ml-1"
            size="sm"
            simple
            filter={{ plan_campaign_block: true }}
          />
          <BoundStateFilterField
            name="income_state"
            placeholder="Income"
            isSearchable={false}
            className="ml-1"
            simple
            size="sm"
          />
          <BoundStateFilterField
            name="expense_state"
            placeholder="Expense"
            isSearchable={false}
            className="ml-1"
            simple
            size="sm"
          />
        </div>
      </div>
    </Box>
  );
}
